import { render } from "./AdminHead.vue?vue&type=template&id=3751bfd1&scoped=true&ts=true"
import script from "./AdminHead.vue?vue&type=script&lang=ts"
export * from "./AdminHead.vue?vue&type=script&lang=ts"

import "./AdminHead.vue?vue&type=style&index=0&id=3751bfd1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3751bfd1"]])

export default __exports__